





















































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component } from "vue-property-decorator";
import { UserInterface } from "@/resources/interfaces/userInterfaces";
import { i18n } from "@/resources/locales";
import { mixins } from "vue-class-component";
import VueTagsInput from "@johmun/vue-tags-input";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { Validate } from "vuelidate-property-decorators";
import { required, email } from "vuelidate/lib/validators";
import moment from "moment";
import { LANGUAGES } from "@/resources/constants/userLanguages";
import { LANGUAGES_LEVEL } from "@/resources/constants/languageLevel";
import { DIGITAL_SKILL_LEVEL } from "@/resources/constants/digitalSkillLevel";
import { GENDER } from "@/resources/constants/gender";
import { NATIONALITY } from "@/resources/constants/nationality";
@Component({
  name: "profile-curriculum-component",
  components: {
    VueTagsInput,
  },
})
export default class CurriculumComponent extends mixins(
  Vue,
  NotificationEvent
) {
  LANGUAGES = LANGUAGES;
  LANGUAGES_LEVEL = LANGUAGES_LEVEL;
  DIGITAL_SKILL_LEVEL = DIGITAL_SKILL_LEVEL;
  GENDER = GENDER;
  NATIONALITY = NATIONALITY;
  activePersonalInformation = true;
  @Validate({ required })
  name = "";
  @Validate({ required })
  lastName = "";
  gender: string = "";
  contactAddress = "";
  phone = null;
  phoneNumberPrefix = "";
  @Validate({ required, email })
  email = "";
  link = "";
  birthday = null;
  nationality = "";
  workExperienceId = 0;
  educationId = 0;
  languageSkilllId = 0;
  workExperiences = [];
  educations = [];
  languageSkills = [];
  activeWorkExperiences = true;
  activeEducations = true;
  activeLanguageSkills = true;
  today = null;
  activeDigitalSkill = true;
  informationProcessing = "LOW";
  digitalSkillCommunication = "LOW";
  contentCreation = "LOW";
  safety = "LOW";
  problemSolving = "LOW";
  activeOtherSkill = true;
  otherSkillCommunication = "";
  organizationalOrManagement = "";
  teamWork = "";
  drivingLicense = false;
  activeCurriculum = false;
  loadingCreate = false;
  loadingUpdate = false;
  loadingDelete = false;
  activeAboutYou = true;
  aboutYou = "";
  constructor() {
    super();
    this.today = moment(new Date()).utc().format("yyyy-MM-DD");
    if (!this.user.curriculum) return;
    this.activeCurriculum = true;
    this.name = this.user.curriculum.name;
    this.lastName = this.user.curriculum.lastName;
    this.gender =
      this.user.curriculum.gender == null ? "" : this.user.curriculum.gender;
    this.contactAddress = this.user.curriculum.contactAddress;
    this.phone = this.user.curriculum.phoneNumber;
    this.phoneNumberPrefix = this.user.curriculum.phoneNumberPrefix;
    this.email = this.user.curriculum.email;
    this.link = this.user.curriculum.link;
    this.birthday = moment
      .utc(this.user.curriculum.dateOfBirth)
      .format("yyyy-MM-DD");
    this.nationality =
      this.user.curriculum.nationality == null
        ? ""
        : this.user.curriculum.nationality;
    this.workExperiences = this.user.curriculum.workExperiences;
    this.educations = this.user.curriculum.educations;
    this.languageSkills = this.user.curriculum.languageSkills;
    this.informationProcessing =
      this.user.curriculum.digitalSkill.informationProcessing;
    this.otherSkillCommunication =
      this.user.curriculum.digitalSkill.communication;
    this.contentCreation = this.user.curriculum.digitalSkill.contentCreation;
    this.safety = this.user.curriculum.digitalSkill.safety;
    this.problemSolving = this.user.curriculum.digitalSkill.problemSolving;
    this.otherSkillCommunication =
      this.user.curriculum.otherSkill.communication;
    this.organizationalOrManagement =
      this.user.curriculum.otherSkill.organizationalOrManagement;
    this.teamWork = this.user.curriculum.otherSkill.teamWork;
    this.drivingLicense = this.user.curriculum.otherSkill.drivingLicense;
    this.aboutYou = this.user.curriculum.aboutYou;
  }
  mounted() {}
  get user(): UserInterface {
    return this.$store.getters["UserStore/getUser"];
  }
  set user(user) {
    this.$store.dispatch("UserStore/setUserAction", user);
  }
  clearData() {
    this.name = "";
    this.lastName = "";
    this.gender = "";
    this.contactAddress = "";
    this.phone = null;
    this.phoneNumberPrefix = "";
    this.email = "";
    this.link = "";
    this.birthday = null;
    this.nationality = "";
    this.workExperiences = [];
    this.educations = [];
    this.languageSkills = [];
    this.informationProcessing = "LOW";
    this.digitalSkillCommunication = "LOW";
    this.contentCreation = "LOW";
    this.safety = "LOW";
    this.problemSolving = "LOW";
    this.otherSkillCommunication = "";
    this.organizationalOrManagement = "";
    this.teamWork = "";
    this.drivingLicense = false;
    this.aboutYou = "";
  }
  addWorkExperience() {
    this.workExperienceId++;
    this.workExperiences.push({
      idLocal: this.workExperienceId * -1,
      position: "",
      startAt: null,
      endAt: null,
      company: "",
      companyType: "",
      description: "",
    });
  }
  addEducation() {
    this.educationId++;
    this.educations.push({
      idLocal: this.educationId * -1,
      title: "",
      startAt: null,
      finishAt: null,
      place: "",
      description: "",
    });
  }
  addLanguageSkillls() {
    this.languageSkilllId++;
    this.languageSkills.push({
      idLocal: this.languageSkilllId * -1,
      language: "",
      listeningSkill: "",
      speakingSkill: "",
      readingSkill: "",
      writingSkill: "",
    });
  }
  removeWorkExperience(data: any) {
    if ("id" in data) {
      this.workExperiences = this.workExperiences.filter(function (object) {
        return object.id !== data.id;
      });
    } else if ("idLocal" in data) {
      this.workExperiences = this.workExperiences.filter(function (object) {
        return object.idLocal !== data.idLocal;
      });
    }
  }
  removeEducation(data: any) {
    if ("id" in data) {
      this.educations = this.educations.filter(function (object) {
        return object.id !== data.id;
      });
    } else if ("idLocal" in data) {
      this.educations = this.educations.filter(function (object) {
        return object.idLocal !== data.idLocal;
      });
    }
  }
  removeLanguageSkillls(data: any) {
    if ("id" in data) {
      this.languageSkills = this.languageSkills.filter(function (object) {
        return object.id !== data.id;
      });
    } else if ("idLocal" in data) {
      this.languageSkills = this.languageSkills.filter(function (object) {
        return object.idLocal !== data.idLocal;
      });
    }
  }
  sendCurriculum() {
    this.loadingCreate = true;
    this.$store.dispatch("UserStore/setCurriculumAction", {
      data: this.createCV(),
      callback: (response) => {
        this.loadingCreate = false;
        this.user.curriculum = response;
        this.user = this.user;
        this.activeCurriculum = true;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.createCurriculum")
        );
      },
      callbackError: (error) => {
        console.log(" TTT sendCurriculum KO ", error);
        this.loadingCreate = false;
        this.onError(
          "",
          i18n.t("notifications.genericError.genericError", {
            code: error.response.status,
          })
        );
      },
    });
  }
  updateCurriculum() {
    this.loadingUpdate = true;
    this.$store.dispatch("UserStore/updateCurriculumAction", {
      id: this.user.curriculum.id,
      data: this.createCV(),
      callback: (response) => {
        this.loadingUpdate = false;
        this.user.curriculum = response;
        this.user = this.user;
        this.activeCurriculum = true;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.updateCurriculum")
        );
      },
      callbackError: (error) => {
        console.log(" TTT updateCurriculum KO ", error);
        this.loadingUpdate = false;
        this.onError(
          "",
          i18n.t("notifications.genericError.genericError", {
            code: error.response.status,
          })
        );
      },
    });
  }
  deleteCurriculum() {
    this.loadingDelete = true;
    this.$store.dispatch("UserStore/deleteCurriculumAction", {
      id: this.user.curriculum.id,
      callback: (response) => {
        this.loadingDelete = false;
        this.user.curriculum = null;
        this.user = this.user;
        this.clearData();
        this.activeCurriculum = false;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.deleteCurriculum")
        );
      },
      callbackError: (error) => {
        console.log(" TTT deleteCurriculum KO ", error);
        this.loadingDelete = false;
        this.onError(
          "",
          i18n.t("notifications.genericError.genericError", {
            code: error.response.status,
          })
        );
      },
    });
  }
  checkForm() {
    if (this.$v.$invalid) {
      this.$v.name.$touch();
      this.$v.lastName.$touch();
      this.$v.email.$touch();
      return true;
    }
    for (let experience of this.workExperiences) {
      if (
        !experience.position ||
        experience.position.trim() === "" ||
        !experience.startAt ||
        experience.startAt.trim() === "" ||
        !experience.company ||
        experience.company.trim() === "" ||
        !experience.companyType ||
        experience.companyType.trim() === ""
      ) {
        return true;
      }
    }
    for (let education of this.educations) {
      if (
        !education.title ||
        education.title.trim() === "" ||
        !education.startAt ||
        education.startAt.trim() === "" ||
        !education.place ||
        education.place.trim() === ""
      ) {
        return true;
      }
    }
    for (let languageSkill of this.languageSkills) {
      if (
        !languageSkill.language ||
        languageSkill.language.trim() === "" ||
        !languageSkill.listeningSkill ||
        languageSkill.listeningSkill.trim() === "" ||
        !languageSkill.speakingSkill ||
        languageSkill.speakingSkill.trim() === "" ||
        !languageSkill.readingSkill ||
        languageSkill.readingSkill.trim() === "" ||
        !languageSkill.writingSkill ||
        languageSkill.writingSkill.trim() === ""
      ) {
        return true;
      }
    }
    return false;
  }
  createCV() {
    let data = null;
    let dateOfBirth = moment(this.birthday).isValid()
      ? moment(this.birthday).format("yyyy-MM-DD HH:mm:ss")
      : null;
    if (!this.activeCurriculum)
      data = {
        name: this.name,
        lastName: this.lastName,
        gender: this.gender ? this.gender : null,
        contactAddress: this.contactAddress,
        phoneNumber: this.phone,
        phoneNumberPrefix: this.phoneNumberPrefix,
        email: this.email,
        link: this.link,
        dateOfBirth: dateOfBirth,
        nationality: this.nationality ? this.nationality : null,
        workExperiences: this.workExperiences,
        educations: this.educations,
        languageSkills: this.languageSkills,
        digitalSkill: {
          informationProcessing: this.informationProcessing,
          communication: this.digitalSkillCommunication,
          contentCreation: this.contentCreation,
          safety: this.safety,
          problemSolving: this.problemSolving,
        },
        otherSkill: {
          communication: this.otherSkillCommunication,
          organizationalOrManagement: this.organizationalOrManagement,
          teamWork: this.teamWork,
          drivingLicense: this.drivingLicense,
        },
        aboutYou: this.aboutYou,
      };
    else
      data = {
        name: this.name,
        lastName: this.lastName,
        gender: this.gender ? this.gender : null,
        contactAddress: this.contactAddress,
        phoneNumber: this.phone,
        phoneNumberPrefix: this.phoneNumberPrefix,
        email: this.email,
        link: this.link,
        dateOfBirth: dateOfBirth,
        nationality: this.nationality ? this.nationality : null,
        workExperiences: this.workExperiences,
        educations: this.educations,
        languageSkills: this.languageSkills,
        digitalSkill: {
          id: this.user.curriculum.digitalSkill.id,
          informationProcessing: this.informationProcessing,
          communication: this.digitalSkillCommunication,
          contentCreation: this.contentCreation,
          safety: this.safety,
          problemSolving: this.problemSolving,
        },
        otherSkill: {
          id: this.user.curriculum.otherSkill.id,
          communication: this.otherSkillCommunication,
          organizationalOrManagement: this.organizationalOrManagement,
          teamWork: this.teamWork,
          drivingLicense: this.drivingLicense,
        },
        aboutYou: this.aboutYou,
      };
    return data;
  }
}
